<template>
  <b-table
    :fields="table.fields"
    :items="items"
    :empty-text="$t('GERAL.NENHUM_REGISTRO')"
    head-variant="light"
    stacked="md"
    responsive
    show-empty
    striped
    hover
  />
</template>
<script>
// Utils & Aux:
import helpers from '@/common/utils/helpers';

export default {
  props: {
    dados: { type: Object, default: Object },
  },
  computed: {
    items() {
      return this.dados.notasFiscaisItens;
    },
  },
  data() {
    return {
      table: {
        fields: [
          {
            key: 'produtoDescricao',
            label: this.$t('SUPRIMENTOS_LANCAMENTOS_NF.PRODUTO'),
            sortable: true,
          },
          {
            key: 'quantidade',
            label: this.$t('SUPRIMENTOS_LANCAMENTOS_NF.QUANTIDADE'),
            sortable: true,
          },
          {
            key: 'valorUnitario',
            label: this.$t('SUPRIMENTOS_LANCAMENTOS_NF.VALOR_UNITARIO'),
            formatter: (value) => {
              return value ? helpers.formatarReal(value) : '-';
            },
            sortable: true,
          },
          {
            key: 'valorTotal',
            label: this.$t('SUPRIMENTOS_LANCAMENTOS_NF.VALOR_TOTAL'),
            formatter: (value) => {
              return value ? helpers.formatarReal(value) : '-';
            },
            sortable: true,
          },
          {
            key: 'depositoDescricao',
            label: this.$t('SUPRIMENTOS_LANCAMENTOS_NF.DEPOSITO'),
            sortable: true,
          },
        ],
      },
    };
  },
};
</script>
